import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParentAuthService } from '../parent-auth.service';
import { AccountApiService } from '../../core/api/services';

@Component({
  selector: 'app-parent-signin',
  templateUrl: './parent-signin.component.html',
  styleUrls: ['./parent-signin.component.css'],
  standalone: false,
})
export class ParentSignInComponent implements OnInit {
  loading: boolean = false;
  errorMessage: string = '';
  clientPortalUrl = '';
  isError = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private parentAuthService: ParentAuthService,
    private accountApi: AccountApiService
  ) { }

  ngOnInit(): void {
    this.accountApi.GeneralSettings().subscribe({
      next: settings => { this.clientPortalUrl = settings.ClientPortalUrl ?? ''; },
      error: () => { this.clientPortalUrl = ''; }
    });
    const code = this.route.snapshot.queryParamMap.get('code');

    if (!code) {
      if (this.parentAuthService.isSignedIn()) {
        this.router.navigate(['/parent/home'], { replaceUrl: true });
      } else {
        this.errorMessage = "You're signed out of Spark.";
      }
      return;
    }

    this.loading = true;
    this.parentAuthService.signIn(code).subscribe({
      next: () => {
        this.loading = false;
        // replaceUrl drops the spent one-time code from history.
        this.router.navigate(['/parent/home'], { replaceUrl: true });
      },
      error: (err) => {
        this.loading = false;
        this.isError = true;
        this.errorMessage = (typeof err?.error === 'string' ? err.error : err?.error?.Message || err?.error?.message || err?.Message)
          || 'This link is no longer valid. Please open Spark from the Client Portal again.';
      }
    });
  }
}
